import * as React from "react";
const SvgUserTieSolid = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path d="M224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-14.9 103.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3 70.1 17.6 121.9 81 121.9 156.4 0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8.7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4 8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z" />
  </svg>
);
export default SvgUserTieSolid;
